// Docs: https://developers.cloudflare.com/images/transform-images
export default function cloudflareLoader({
  src,
  width,
  quality,
}) {
  const params = [`width=${width}`, `quality=${quality || 80}`, 'format=auto'];
  return `https://www.schimmel-automobile.de/cdn-cgi/image/${params.join(',')}/${src?.startsWith('/') ? src : encodeURIComponent(src)}`;
}
